<template>
    <div>
        <!-- 页面导航栏 -->
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-document"></i> 定价类型管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 主容器 -->
        <div class="container">
            <!-- 搜索区域 -->
            <div class="handle-box">
                <el-input v-model="name" placeholder="请输入定价类型编号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button style="float:right" type="primary" v-if="perData.allow_add == 1" @click="handleAdd">{{ $t('common.add') }}
                </el-button>

            </div>
            <!-- 数据表格 -->
            <el-table :data="tableData" border stripe class="table" ref="multipleTable"
                      header-cell-class-name="table-header">
                <!-- 表格列定义 -->
                <el-table-column type="index" label="序号" width="90" align="center"></el-table-column>
                <el-table-column prop="pricingtype_no" label="定价类型编号" align="center"></el-table-column>
                <el-table-column prop="pricingtype_name" label="定价类型名称" align="center"></el-table-column>
                <el-table-column prop="type" label="类型" align="center">
                    <template slot-scope="scope">
                        <el-tag
                            :type="getTypeTagType(scope.row.type)"
                            size="mini"
                        >
                            {{ getTypeName(scope.row.type) }}
                        </el-tag>
                    </template>
                </el-table-column>


                <el-table-column v-if="systemSet.isstores == 1" prop="store_no" label="所属门店编号"
                                 align="center"></el-table-column>
                <el-table-column v-if="systemSet.isstores == 1" prop="store_name" label="所属门店名称"
                                 align="center"></el-table-column>
                <!-- 启用状态列 -->
                <el-table-column label="启用" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
                                   @change="tableDatastates(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>

                <!-- 默认状态列 -->
                <el-table-column label="默认" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isdefault" :active-value="1" :inactive-value="0"
                                   @change="tableDatastates(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column prop="remark" :label="$t('common.remark')" align="center"></el-table-column>

                <!-- 操作列（仅允许编辑时显示） -->
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row)"
                                   v-if="perData.allow_edit == 1">{{ $t('common.edit') }}
                        </el-button>
                        <el-button type="danger" plain @click="handleDelete(scope.row)" v-if="perData.allow_dele == 1">
                            {{ $t('common.delete') }}
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <!-- 分页组件 -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 30]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑对话框 -->
        <el-dialog :title="$t('common.edit')" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <el-form ref="form" :model="editForm" label-width="120px">
                <!-- 表单字段 -->
                <el-form-item label="定价类型编号">
                    <el-input v-model="editForm.pricingtype_no" disabled></el-input>
                </el-form-item>
                <el-form-item label="定价类型名称">
                    <el-input v-model="editForm.pricingtype_name"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-radio v-model="editForm.type" :label=1>销售</el-radio>
                    <el-radio v-model="editForm.type" :label=2>回购</el-radio>
                    <el-radio v-model="editForm.type" :label=3>来料不结价</el-radio>
                    <el-radio v-model="editForm.type" :label=4>提料不结价</el-radio>
                </el-form-item>
                <el-form-item label="所属门店" prop="store_no" v-if="systemSet.isstores == 1">
                    <el-select
                        v-model="editForm.store_no"
                        clearable
                        filterable
                        default-first-option
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="(item, index) in pullData.store"
                            :key="index"
                            :label="item.store_name"
                            :value="item.store_no"
                        >
                            <span style="margin-left: 10px">{{ item.store_name }}</span>
                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('common.remark')">
                    <el-input v-model="editForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="editFormData">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 新增对话框 -->
        <el-dialog :title="$t('common.add')" :visible.sync="addDialogVisible" width="30%" :before-close="handleAddClose">
            <el-form ref="addForm" :model="addForm" label-width="120px">
                <!-- 表单字段 -->
                <el-form-item label="定价类型编号">
                    <el-input v-model="addForm.pricingtype_no"></el-input>
                </el-form-item>
                <el-form-item label="定价类型名称">
                    <el-input v-model="addForm.pricingtype_name"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-radio v-model="addForm.type" :label=1>销售</el-radio>
                    <el-radio v-model="addForm.type" :label=2>回购</el-radio>
                    <el-radio v-model="addForm.type" :label=3>来料不结价</el-radio>
                    <el-radio v-model="addForm.type" :label=4>提料不结价</el-radio>
                </el-form-item>
                <el-form-item label="所属门店" prop="store_no" v-if="systemSet.isstores == 1">
                    <el-select
                        v-model="addForm.store_no"
                        clearable
                        filterable
                        default-first-option
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="(item, index) in pullData.store"
                            :key="index"
                            :label="item.store_name"
                            :value="item.store_no"
                        >
                            <span style="margin-left: 10px">{{ item.store_name }}</span>
                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('common.remark')">
                    <el-input v-model="addForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleAddClose">取 消</el-button>
                <el-button type="primary" @click="saveAdd">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// 导入 API 接口
import {
    apiGetPricingTypeStatusList,
    apiCurrentPermisson,
    apiPricingTypeManagePull,
    apiAddPricingTypeData,
    apiUpdatePricingTypeStatus,
    apiUpdatePricingTypeData,
    apiDeletePricingTypeData
} from '@/request/api';

export default {
    name: 'basetable',
    data() {
        return {
            addForm: {},
            editForm: {},
            dialogVisible: false,
            addDialogVisible: false,
            pullData: [],
            name: '',
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            perData: '',
            pageTotal: 0,
            systemSet: JSON.parse(localStorage.getItem('systemSet'))
        };
    },
    mounted() {
        // 组件挂载时加载数据
        this.getPull();
        this.getData();
        this.getPermission();
    },
    activated() {
        // keep-alive 缓存组件激活时刷新数据
        this.getPull();
        this.getData();
        this.getPermission();
    },
    methods: {
        // 获取类型标签的颜色类型
        getTypeTagType(type) {
            switch (type) {
                case 1: return 'primary';   // 销售 - 蓝色
                case 2: return 'warning';   // 回购 - 橙色
                case 3: return 'success';   // 来料不结价 - 绿色
                case 4: return 'danger';    // 提料不结价 - 红色
                default: return 'info';     // 其他 - 灰色
            }
        },
        // 获取类型名称
        getTypeName(type) {
            switch (type) {
                case 1: return '销售';
                case 2: return '回购';
                case 3: return '来料不结价';
                case 4: return '提料不结价';
                default: return '';
            }
        },
        getPull() {
            apiPricingTypeManagePull().then(res => {
                if (res.code == 2000) {
                    this.pullData = res.data;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        // 编辑操作----------------------------------------------------------------------------------------------------
        // 编辑按钮点击事件
        handleEdit(row) {
            this.dialogVisible = true;
            // 创建 row 的深拷贝，避免直接引用原始数据
            this.editForm = JSON.parse(JSON.stringify(row));
        },
        // 提交编辑表单
        editFormData() {
            apiUpdatePricingTypeData(this.editForm).then((res) => {
                if (res.code === 2000) {
                    this.$message.success(res.msg); // 成功提示
                    this.getData(); // 刷新表格数据
                    this.handleClose(); // 关闭对话框
                } else {
                    this.$message.error(res.data.info);// 失败提示
                }
            });
        },
        // 关闭编辑对话框
        handleClose() {
            this.editForm = {};// 清空表单数据
            this.dialogVisible = false; // 隐藏对话框
        },
        //添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.addDialogVisible = true;
            this.addForm = {};

            this.$nextTick(() => {
                if (this.pullData.store) {
                    const defaultStore = this.pullData.store.find((store) => store.isdefault == 1);
                    this.$set(this.addForm, 'store_no', defaultStore ? defaultStore.store_no : '');
                }
            });
        },
        saveAdd() {
            apiAddPricingTypeData(this.addForm).then(res => {
                if (res.code == 2000) {
                    this.$message({ message: '添加成功', type: 'success' });
                    this.addDialogVisible = false;
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        handleAddClose() {
            this.addForm = {};
            this.addDialogVisible = false;
        },
        // 删除操作----------------------------------------------------------------------------------------------------
        handleDelete(row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let data = {
                        pricingtype_no: row.pricingtype_no // 定价类型编号
                    };
                    apiDeletePricingTypeData(data).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {
                });
        },

        // 锁定状态切换事件
        tableDatastates(row) {
            let data = {
                pricingtype_no: row.pricingtype_no, // 定价类型编号
                store_no: row.store_no, // 门店编号
                islock: row.islock, // 锁定状态（1=锁定，0=解锁）
                status: row.status, // 启用状态（1=启用，0=停用）
                isdefault: row.isdefault // 默认状态（1=是，0=否）
            };
            apiUpdatePricingTypeStatus(data).then((res) => {
                if (res.code === 2000) {
                    this.$message.success(res.msg);// 成功提示
                } else {
                    this.$message.error(res.data.info); // 失败提示
                }
                this.getData(); // 刷新表格数据
            });
        },
        // 获取列表信息
        getData() {
            this.$load.show(); // 显示加载动画
            apiGetPricingTypeStatusList({
                page: this.pageIndex, // 当前页码
                page_size: this.pageSize, // 每页数量
                seek: this.name// 搜索关键字
            }).then((res) => {
                if (res.code == 2000) {
                    this.tableData = res.data.data;// 赋值表格数据
                    this.pageTotal = res.data.count;// 赋值总数据量
                } else {
                    this.$message.error(res.data.info);// 错误提示
                }
            });
            this.$load.close(); // 关闭加载动画
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '173' // 权限ID（需根据实际ID调整）
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;// 赋值权限数据
                } else {
                    this.$message.error(res.msg); // 错误提示
                }
            });
        },
        // 搜索按钮点击事件
        handleSearch() {
            this.pageIndex = 1;// 重置为第一页
            this.getData();// 重新加载数据
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val; // 更新当前页码
            this.getData();// 重新加载数据
        },
        pageSizeChange(val) {
            this.pageSize = val; // 更新每页数量
            this.getData(); // 重新加载数据
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}

.el-table th {
    background: #ecf5ff !important;
}

.el-dialog {
    width: 40%;
}

@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }

    .el-message-box {
        width: 100%;
    }

    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
